import { lazyLoad } from 'utils/lazy';

export const UserLogs = lazyLoad(
  () => import('./UserLogsPage'),
  (module) => module.UserLogsPage
);

export * from './UserLogsPage';
